module.exports = __webpack_public_path__ + "img/advantage-1.a03889b2.png";